import {
  BASE_ARTICLE_45,
  BASE_MANAGEMENT_AGREEMENT,
} from 'src/app/_services/constants/base-contracts-info';
import { ContractToSignInfo } from 'src/app/_services/types/contract-template.types';
import { SharedFunnelDatalayerEvent } from 'src/app/_services/types/datalayer.types';
import { Step } from 'src/app/_services/types/step.type';
import { ContractType } from 'src/app/enums/contract-type.enum';
import { InsuranceTypeEnum } from 'src/app/enums/insurance-type.enum';
import { LinearStepperElement } from 'src/app/ui-kit/components/linear-stepper/linear-stepper.component';

import { BUSINESS_INSURANCE_BASE } from '../company-insurance-constants';

export const BUSINESS_CENTRALISATION_INSURANCE_BASE = 'centralisation';

export const BUSINESS_CENTRALISATION_FORM_BASE = `${BUSINESS_INSURANCE_BASE}/${BUSINESS_CENTRALISATION_INSURANCE_BASE}`;

export const CONTRACTS_TO_SIGN: ContractToSignInfo[] = [
  {
    ...BASE_ARTICLE_45,
    name: 'Article 45 centralisation',
    type: ContractType.ARTICLE_45,
    insuranceType: InsuranceTypeEnum.CENTRALISATION,
  },
  {
    ...BASE_MANAGEMENT_AGREEMENT,
    name: 'Mandat gestion centralisation',
    type: ContractType.MANAGEMENT_AGREEMENT,
    insuranceType: InsuranceTypeEnum.CENTRALISATION,
  },
];

export const BUSINESS_CENTRALISATION_FUNNEL_EVENT_BASE: SharedFunnelDatalayerEvent = {
  event: 'Wallet_Centralisation entreprise',
  product_category: 'Centralisation entreprise',
  product_name: 'Wallet',
  funnel_complete: false,
};

export const BUSINESS_CENTRALISATION_STEPS: {
  INSURANCES: Step;
  ACCOUNT: Step;
  LOGIN: Step;
  REGISTER: Step;
  SIGNATURE: Step;
  END: Step;
} = {
  INSURANCES: {
    step: [1, 1],
    url: 'informations-produit',
    datalayerEvent: {
      ...BUSINESS_CENTRALISATION_FUNNEL_EVENT_BASE,
      funnel_stage: 2,
      stage_name: 'Informations produit',
    },
  },
  ACCOUNT: {
    step: [2, 1],
    url: 'compte',
    datalayerEvent: {
      ...BUSINESS_CENTRALISATION_FUNNEL_EVENT_BASE,
      funnel_stage: 4,
      stage_name: 'Compte',
    },
  },
  LOGIN: {
    step: [2, 1],
    url: 'connexion',
    datalayerEvent: {
      ...BUSINESS_CENTRALISATION_FUNNEL_EVENT_BASE,
      funnel_stage: 5,
      stage_name: 'Connexion',
    },
  },
  REGISTER: {
    step: [2, 1],
    url: 'inscription',
    datalayerEvent: {
      ...BUSINESS_CENTRALISATION_FUNNEL_EVENT_BASE,
      funnel_stage: 5,
      stage_name: 'Inscription',
    },
  },
  SIGNATURE: {
    step: [3, 1],
    url: 'signature',
    datalayerEvent: {
      ...BUSINESS_CENTRALISATION_FUNNEL_EVENT_BASE,
      funnel_stage: 6,
      stage_name: 'Signatures',
    },
  },
  END: {
    step: [4, 1],
    url: 'fin',
    datalayerEvent: {
      ...BUSINESS_CENTRALISATION_FUNNEL_EVENT_BASE,
      funnel_stage: 7,
      stage_name: 'Fin',
      funnel_complete: true,
    },
  },
};

export const BUSINESS_CENTRALISATION_STEPS_NAMES: LinearStepperElement[] = [
  {
    title: $localize`Assurances à centraliser`,
  },
  {
    title: $localize`Compte`,
  },
  {
    title: $localize`Signature de contrat`,
  },
  {
    title: $localize`Fin`,
  },
];

export const END_SCREEN_TEXTS: LinearStepperElement[] = [
  {
    title: $localize`Nous y voilà, maintenant LTY se charge de contacter la/les compagnie(s) pour recevoir tes polices`,
  },
  {
    title: $localize`Nous intégrons ta/tes police(s) au Wallet digital`,
  },
  {
    title: $localize`Ta /tes polices(s) sont accessible(s) dans ton Wallet`,
  },
];
